<div class="flex items-center justify-center dialog-header ">
    {{formAction}} User

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div>
        <div class="row">
            <div class="col-md-12">
                <form #userForm="ngForm">
                    <p-fieldset legend="User Details">
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-5 mt-3">
                            <div class="flex flex-col">
                                <label class="font-medium">Prefix</label>
                                <p-select class="no-shadow-select" [options]="prefixOptions" [(ngModel)]="user.prefix"
                                    name="prefix" #prefix="ngModel" required></p-select>
                                <div *ngIf="prefix.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="prefix.errors['required']">Prefix is required</div>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">First Name</label>
                                <input pInputText type="text" required [(ngModel)]="user.fname" name="fname"
                                    #fname="ngModel" class="border p-2 rounded-md no-shadow-input">
                                <div *ngIf="fname.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="fname.errors['required']">First Name is required</div>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Last Name</label>
                                <input pInputText type="text" required [(ngModel)]="user.lname" name="lname"
                                    #lname="ngModel" class="border p-2 rounded-md no-shadow-input">
                                <div *ngIf="lname.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="lname.errors['required']">Last Name is required</div>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Gender</label>
                                <p-select [options]="genderOptions" class="no-shadow-select" [(ngModel)]="user.gender"
                                    name="gender" #gender="ngModel" required></p-select>
                                <div *ngIf="gender.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="gender.errors['required']">Gender is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5">
                            <div class="font-medium mb-2" style="margin-bottom: 5px;">Professional Details</div>
                            <textarea pTextarea [(ngModel)]="user.details" name="profile" #profile="ngModel"
                                class="w-full border p-2 rounded-md"></textarea>
                        </div>
                    </p-fieldset>
                    <br />
                    <p-fieldset legend="Account Details" styleClass="mt-5">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-3">
                            <div class="flex flex-col">
                                <label class="font-medium">Department</label>
                                <p-select id="department" class="no-shadow-select" [options]="departmentsList"
                                    optionLabel="label" optionValue="value" required="true" #dept_id="ngModel"
                                    [(ngModel)]="user.dept_id" name="dept_id" placeholder="Select Department">
                                </p-select>

                                <div *ngIf="dept_id.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="dept_id.errors['required']">Department is required</div>
                                </div>

                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Role</label>
                                <p-select id="role" class="no-shadow-select" required="true" #role_id="ngModel"
                                    [options]="roles" optionLabel="name" optionValue="role_id"
                                    [(ngModel)]="user.role_id" name="role_id" placeholder="Select Role">
                                </p-select>

                                <div *ngIf="role_id.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="role_id.errors['required']">Role is required</div>
                                </div>

                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Status</label>
                                <p-select class="no-shadow-select" id="status" required="true" #status="ngModel"
                                    [options]="[{ label: 'Active', value: 'Active' }, { label: 'Inactive', value: 'Inactive' }]"
                                    [(ngModel)]="user.status" name="status" placeholder="Select Status">
                                </p-select>

                                <div *ngIf="status.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="status.errors['required']">Status is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
                            <div class="flex flex-col">
                                <label class="font-medium">Username</label>
                                <input class="no-shadow-input" pInputText
                                [disabled]="formAction === 'Edit'"
                                id="username" [(ngModel)]="user.username"
                                    name="username" required="true" #username="ngModel" />

                                <div *ngIf="username.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="username.errors['required']">Username is required</div>
                                </div>

                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Email</label>
                                <input pInputText id="email" class="no-shadow-input" [(ngModel)]="user.email"
                                    name="email"  required="true" #email="ngModel" />

                                <div *ngIf="email.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="email.errors['required']">Email is required</div>
                                </div>
                            </div>

                            <div class="flex flex-col">
                                <label class="font-medium">Two Factor Authentication</label>
                                <p-select id="twoFactorAuthentication"
                                    [options]="[{ label: 'Active', value: true }, { label: 'Inactive', value: false }]"
                                    class="no-shadow-select" [(ngModel)]="user.twoFactorAuthentication"
                                    name="twoFactorAuthentication" placeholder="Select Two Factor Authentication">
                                </p-select>
                            </div>
                            <div class="flex flex-col" *ngIf="formAction === 'Add'">
                            <div class="inputdiv">
                                <label for="password" style="margin-bottom: 10px;" class="font-medium">
                                    Password
                                </label>
                            
                                <p-password class="passwordInput mt-2"
                                    [toggleMask]="true"  
                                    name="password" 
                                    autocomplete="false"
                                    [(ngModel)]="user.password" 
                                    aria-required="true"
                                    required
                                    (ngModelChange)="user.password = user.password.trim()">
                                    
                                    <ng-template #header>
                                        <div class="font-semibold text-xm mb-1"></div>
                                    </ng-template>
                            
                                    <ng-template #footer>
                                        <hr class="my-2 text-[#CDCBCB]" style="background-color: #CDCBCB; height: 1px; border-color: #CDCBCB;" />
                                        <ul class="pl-2 ml-2 leading-normal flex flex-col gap-3 mt-3">
                                            <li [ngClass]="{'text-green-500': lowercase, 'text-red-500': !lowercase}">
                                                <span *ngIf="lowercase" class="mr-2">✔</span>
                                                <span *ngIf="!lowercase" class="mr-2">✖</span>
                                                At least one lowercase
                                            </li>
                            
                                            <li [ngClass]="{'text-green-500': uppercase, 'text-red-500': !uppercase}">
                                                <span *ngIf="uppercase" class="mr-2">✔</span>
                                                <span *ngIf="!uppercase" class="mr-2">✖</span>
                                                At least one uppercase
                                            </li>
                            
                                            <li [ngClass]="{'text-green-500': numeric, 'text-red-500': !numeric}">
                                                <span *ngIf="numeric" class="mr-2">✔</span>
                                                <span *ngIf="!numeric" class="mr-2">✖</span>
                                                At least one numeric
                                            </li>
                            
                                            <li [ngClass]="{'text-green-500': minLength, 'text-red-500': !minLength}">
                                                <span *ngIf="minLength" class="mr-2">✔</span>
                                                <span *ngIf="!minLength" class="mr-2">✖</span>
                                                Minimum 8 characters
                                            </li>
                            
                                            <li [ngClass]="{'text-green-500': noWhitespace, 'text-red-500': !noWhitespace}">
                                                <span *ngIf="noWhitespace" class="mr-2">✔</span>
                                                <span *ngIf="!noWhitespace" class="mr-2">✖</span>
                                                Password cannot contain whitespace.
                                            </li>
                                        </ul>
                                    </ng-template>
                                </p-password>
                            
                                <small class="mtErr" *ngIf="isSubmitted && !user.password">
                                    Field is required
                                </small>
                            
                                <small class="mtErr" *ngIf="isSubmitted && !validPassword">
                                    Password must contain at least one number, one uppercase, one lowercase letter, and at least 8 characters.<br />
                                    Password cannot contain whitespace.
                                </small>
                            </div>
                            </div>
                            
                        </div>
                    </p-fieldset>


                </form>
            </div>
        </div>
    </div>
    <div class="modal-footer mt-8 flex items-center gap-4">
        <button pButton type="button" label="Submit" icon="pi pi-save" [disabled]="isLoading" [loading]="isLoading"
            (click)="saveUser(userForm.form.valid)"></button>
        <button pButton label="Close" (click)="handleCloseDialog()" class="p-button-secondary"></button>
    </div>
</div>